<div class="contact-container" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <h3>
    {{ "Contact" | translate }} <span>{{ "Us" | translate }}</span>
  </h3>

  <app-contact-form></app-contact-form>
</div>
